import React from "react";
import PropTypes from "prop-types";

import Typography from "./ui/Typography";
import ArchiveTasteSearchForm from "./ArchiveTasteSearchForm";
import { getArchiveTastePrompts } from "../services/search/archiveTastePrompts";

const SURFACE_COPY = {
  homepageLowerPromo: {
    title: "Search the archive",
    description: "If this release window did not have the right fit, describe the mood, setup, or character dynamic you want next.",
    placeholder: "Try “warm workplace comedy”",
    submitLabel: "Search archive",
    surface: "homepage_lower_promo",
  },
  "shows-like-bottom": {
    title: "Find more shows in the archive",
    description: "If these picks still leave you wanting more, describe the tone, tension, or structure you want next.",
    placeholder: "Try “slow-burn conspiracy thriller”",
    submitLabel: "Search archive",
    surface: "shows_like_bottom",
  },
};

const ArchiveTasteSearchPromo = ({ surfaceKey = "homepageLowerPromo", prompts = [] }) => {
  const copy = SURFACE_COPY[surfaceKey] || SURFACE_COPY.homepageLowerPromo;
  const resolvedPrompts = Array.isArray(prompts) && prompts.length > 0
    ? prompts
    : getArchiveTastePrompts(surfaceKey);

  return (
    <section className="taste-archive-promo" aria-labelledby="archive-taste-search-heading">
      <div className="grid gap-4 lg:grid-cols-[minmax(0,0.9fr)_minmax(18rem,1.1fr)] lg:items-start">
        <div className="space-y-2">
          <div className="space-y-1">
            <Typography id="archive-taste-search-heading" variant="h3" className="text-foreground">
              {copy.title}
            </Typography>
            <Typography variant="body-small" className="max-w-3xl text-foreground/75">
              {copy.description}
            </Typography>
          </div>
        </div>

        <div>
          <ArchiveTasteSearchForm
            id={`${surfaceKey}-archive-taste-search`}
            prompts={resolvedPrompts}
            placeholder={copy.placeholder}
            submitLabel={copy.submitLabel}
            surface={copy.surface}
            compact
          />
        </div>
      </div>
    </section>
  );
};

ArchiveTasteSearchPromo.propTypes = {
  surfaceKey: PropTypes.string,
  prompts: PropTypes.arrayOf(PropTypes.string),
};

export default ArchiveTasteSearchPromo;
